import React from 'react'
import { useQuery } from 'react-query'

import { TeleportToAppSidePanel } from '../../components/SidePanel/SidePanel'

import { useWithAuth } from '../App'
import { AddInquiry } from './AddInquiry'
import { EditInquiry } from './EditInquiry'
import { Loader } from './Loader'
import { Panel } from '../../components/Panel/Panel'

import { Inquiries } from './utils'
import WithFocus from '../../components/WithFocus'

const endpoint = '/form/rest/inquiry/request'

type Props = {
  id: number
  code: string
  onClose: () => void
}

export function InquiryPanel({ id, code, onClose }: Props) {
  const withAuth = useWithAuth()
  const { status, data } = useQuery<{ model: Inquiries }, string>(
    `inquiry-${id}`,
    () =>
      withAuth(
        `${endpoint}/${id}`,
        {
          method: 'GET',
        },
        true
      ),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  )
  const normalisedInquiry = React.useMemo(() => {
    return {
      ...data?.model,
      parent1: { ...data?.model.parent1, email: data?.model.parent1Email },
      parent2: { ...data?.model.parent2, email: data?.model.parent2Email },
      tutor1: { ...data?.model.tutor1, email: data?.model.tutor1Email },
      tutor2: { ...data?.model.tutor2, email: data?.model.tutor2Email },
    }
  }, [data])
  const defaultMentalLevel = React.useMemo(() => {
    const inquiryNames =
      data?.model?.parent1?.type ||
      data?.model?.parent2?.type ||
      data?.model?.tutor1?.type ||
      data?.model?.tutor2?.type
    switch (data && true) {
      case inquiryNames?.includes('KAPP_SNIG'):
        return 'Głęboki'
      case inquiryNames?.includes('KAPP_SNIU'):
        return 'Umiarkowany'
      case inquiryNames?.includes('KAPP_SNIZ'):
        return 'Znaczny'
      default:
        return ''
    }
  }, [data])

  return (
    <TeleportToAppSidePanel>
      <Panel>
        {status === 'loading' && <Loader />}
        {status === 'error' && (
          <WithFocus overflow="auto">
            <AddInquiry id={id} code={code} onClose={onClose} />
          </WithFocus>
        )}
        {data && (
          <WithFocus overflow="auto">
            <EditInquiry
              inquiry={normalisedInquiry}
              onClose={onClose}
              code={code}
              defaultMentalLevel={defaultMentalLevel}
            />
          </WithFocus>
        )}
      </Panel>
    </TeleportToAppSidePanel>
  )
}
